'use client';

/**
 * Responsive Helpers
 */
function isPhone() {
    if (typeof window !== 'undefined') {
        return window.innerWidth < 768;
    }
    return false;
}
function isTablet() {
    if (typeof window !== 'undefined') {
        return window.innerWidth >= 768 && window.innerWidth < 992;
    }
    return false;
}
function isTouch() {
    if (typeof window !== 'undefined') {
        return window.innerWidth < 992;
    }
    return false;
}
function isDesktop() {
    if (typeof window !== 'undefined') {
        return window.innerWidth >= 992;
    }
    return false;
}
var screens = {
    mobile: 768,
    tablet: 991
};

export { isDesktop, isPhone, isTablet, isTouch, screens };
//# sourceMappingURL=responsiveHelper.js.map
